<template>
    <RouterView />

</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style scoped>
    .logo {
        display: block;
        margin: 0 auto 2rem;
    }

    @media (min-width: 1024px) {
        .logo {
            margin: 0 2rem 0 0;
        }
    }
</style>
<style>
    /* THIS is global if NOT scoped */
    .k-table-md {
        font-size: 14px;
    }
</style>
